import localeService from "../service/localeService";

export default (locale = " ") => {
  // 渠道title
  if (APP_CONFIG.htmlTitle) {
    document.title = APP_CONFIG.htmlTitle;
    return;
  }

  const lan = localeService.getTranslate(locale);
  document.title = lan === " " ? "UCloud" : `UCloud - ${lan}`;
};



// WEBPACK FOOTER //
// ./src/common/setTitle.js